import { produce } from "immer";
import {
  kDefaultStartOffset,
  tAdminAction,
  tAdminState,
  tAdminStateImmutable,
  tSetReportOptions,
  tUpdateReport,
} from "./types";

const defaultState: tAdminState = {
  loading: false,
  downloadURL: "",
  reportJSON: {},
  startDate: Date.now() - kDefaultStartOffset,
  endDate: Date.now(),
  salesIncluded: true,
  brandsIncluded: false,
  retailersIncluded: false,
  connectionsIncluded: false,
  productsIncluded: false,
};

const handleFetchAdminReport = (state: tAdminState) => {
  state.loading = !state.loading;
  return state;
};

const handleSetAdminReport = (state: tAdminState, action: tUpdateReport) => {
  state.downloadURL = action.downloadURL;
  state.reportJSON = action.reportJSON;
  state.loading = false;
  return state;
};

const handleSetReportOptions = (state: tAdminState, action: tSetReportOptions) => {
  if (action.startDate) state.startDate = action.startDate;
  if (action.endDate) state.endDate = action.endDate;
  if (action.salesIncluded !== undefined) state.salesIncluded = action.salesIncluded;
  if (action.brandsIncluded !== undefined) state.brandsIncluded = action.brandsIncluded;
  if (action.retailersIncluded !== undefined) state.retailersIncluded = action.retailersIncluded;
  if (action.connectionsIncluded !== undefined) state.connectionsIncluded = action.connectionsIncluded;
  if (action.productsIncluded !== undefined) state.productsIncluded = action.productsIncluded;
  return state;
};

export const AdminReducer = produce((draft: tAdminState = defaultState, action: tAdminAction): tAdminStateImmutable => {
  switch (action.type) {
    case "FETCHING_ADMIN_REPORT":
      return handleFetchAdminReport(draft);
    case "SET_ADMIN_REPORT":
      return handleSetAdminReport(draft, action);
    case "SET_REPORT_OPTIONS":
      return handleSetReportOptions(draft, action);
    default:
      return draft;
  }
});
